import { ACTION } from '@cvent/react-analytics';

export const footerLanguageSelector = {
  id: 'footer_language_selection',
  name: 'Footer Language Selected',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics'],
  objectIdAttribute: 'attendeeId',
  attributes: ['selectedLocale'],
  activityType: 'languageSelector.footer'
};

export const profileLanguageSelector = {
  id: 'profile_language_selection',
  name: 'Profile Language Selected',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics'],
  objectIdAttribute: 'attendeeId',
  attributes: ['selectedLocale'],
  activityType: 'languageSelector.profile'
};
